import React from 'react';
import __fill from 'lodash/fill';

import './FAQTableWrapper.css';

export default class FAQTable extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      showEach: __fill(Array(props.rowItems.length), false),
    };


    this.toggleRow = this.toggleRow.bind(this);
  }

  toggleRow(rowIndex) {
    this.setState(prevState => ({
      showEach: prevState.showEach.map((item, index) => {
        if (index === rowIndex) {
          return !item;
        }
        return item;
      }),
    }))
  }

  render() {
    const { showEach } = this.state;
    const { rowItems } = this.props;
    return (
      <div className="global-faq-table-wrapper">
        <div className="global-faq-title">FAQ</div>
        {
          rowItems.map((item, index) => (
            <div key={item.title} className="row-container">
              <div
                className={`row ${showEach[index] ? 'expanded' : ''}`}
                onClick={() => this.toggleRow(index)}
              >
                <div className="col">
                  <span className="row-title">{item.title}</span>
                  {item.subtitle && <span className="row-subtitle">{item.subtitle}</span>}
                </div>
              </div>
              {showEach[index] &&
                <div className="content" dangerouslySetInnerHTML={{ __html: item.description }} />
              }
            </div>
          ))
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/global/FAQTable/index.js